/**
 * 支付宝内部的技能支付页面（收银台）
 */

import React from 'react';
import { useBrowserTitle, useLocationQuery } from 'hook/index';
import { useProductSelect } from 'hook/product';
import { BlockLoading } from 'component/BlockLoading/BlockLoading';
import { VipHero, PackageGrid, MemberBenefits } from 'component/pay/PayParts';
import styles from './AlipayLanding.module.scss';

export default function AlipayLanding() {
    useBrowserTitle('收银台');
    const searchConf = useLocationQuery();
    const {
        loading,
        productList,
        month,
        setMonth,
        currentProduct,
        price,
    } = useProductSelect('alipay');

    if (loading) {
        return (
            <BlockLoading/>
        );
    }

    const payBtnText = price !== '--' ? `支付宝支付 ¥${price}` : '支付宝支付';

    return (
        <div className={styles.page}>
            {/* VIP 权益头卡 */}
            <VipHero />

            {/* 选择套餐 */}
            <PackageGrid productList={productList} month={month} onSelect={setMonth} />

            {/* 支付方式 */}
            <div className={styles.card}>
                <div className={styles.secTitle}><span className={styles.secBar} /><span>支付方式</span></div>
                <div className={styles.payRow}>
                    <div className={styles.aliLogo}>支</div>
                    <div>
                        <div className={styles.payName}>支付宝 <span className={styles.payRec}>推荐</span></div>
                        <div className={styles.payDesc}>10亿人都在用，真安全，更方便</div>
                    </div>
                    <div className={styles.payTick}>✓</div>
                </div>
            </div>

            {/* 会员权益 */}
            <MemberBenefits />

            {/* 支付 */}
            <form className={styles.payWrap} method="post" action="/alipay/createOrder">
                <input type="hidden" name="token" value={searchConf.str || ''} />
                <input type="hidden" name="appName" value={currentProduct && currentProduct.appName} />
                <input type="hidden" name="months" value={month} />
                <input type="hidden" name="price" value={currentProduct && currentProduct.price} />
                <input type="submit" className={styles.payBtn} value={payBtnText} />
                <div className={styles.note}>虚拟商品不支持退换货，请在购买前确认。</div>
            </form>
        </div>
    );
}
